export default {
  state: {
    branchesList: {
      branches: []
    },
    branchInfo: {
      users: [],
      courses: [],
      leader: {}
    },
    branchCourses: [],
    commissionsList: {}
  },
  mutations: {
    setBranchesList: (state, { list }) => {
      state.branchesList = list
    },
    setBranchInfo: (state, { list }) => {
      state.branchInfo = list
    },
    setBranchCourses: (state, { list }) => {
      state.branchCourses = list
    },
    setCommissionsList: (state, { list }) => {
      state.commissionsList = list
    }
  },
  actions: {}
}